// 指定组织的树状列表
import {queryByOrgTree} from "@api/core/org";

// 按模块的action, reducer整合体
const DEPARTMENT_LIST = 'CDEPARTMENT_LIST';

export function getDepartmentList(params) {
  return (dispatch, getState) => {
    queryByOrgTree({
      ...params,
    }).then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: DEPARTMENT_LIST,
          data: res.data,
        });
      }
    });
  };
}

export function departmentList(state = [], action) {
  switch (action.type) {
    case DEPARTMENT_LIST:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/department_list.js